'use strict';

import angular from 'angular';

import saCarousel from './carousel.directive';
import saCarouselContainer from './carousel_container.directive';
import saCarouselControl from './carousel_control.directive';
import saCarouselItem from './carousel_item.directive';

export default angular
  .module('common.carousel', [])
  .directive('saCarousel', saCarousel)
  .directive('saCarouselContainer', saCarouselContainer)
  .directive('saCarouselControl', saCarouselControl)
  .directive('saCarouselItem', saCarouselItem)
  .name;



// WEBPACK FOOTER //
// ./app/src/common/carousel/index.js